// import React, { useState, useEffect, useMemo, memo, useRef } from "react";
// import GRPOSearch from "./GRPOSearch";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate } from 'react-router-dom';
// import { GetGrpoData, GetGrpoItmData, PostItemCoilId  } from "../../../APIServices/ProductionService/GRPOServices/grpoThunk";
// import GRPOTable from "./GRPOTable";
// import GRPOModal from "./GRPOModal";
// import { HashLoader } from "react-spinners";
// import { commonFilter,validateDecimalInput } from "../../../SharedFiles/Helper/utils";
// import { BiArrowBack } from 'react-icons/bi';
// import './GRPO.css';
// import Footer from "../../../SharedFiles/Footer/Footer";
// import { toast, Toaster } from 'react-hot-toast';
// import QRCodeGenerator from "../../../SharedFiles/QRCode/qrGenerator";
// import { showNavigateConfirmation, showSubmitConfirmation } from "../../../SharedFiles/WarningMessage/deleteWarning";
// import { useTranslation } from 'react-i18next';
// import { useQRModal } from "../../../../Context/QrContext";

// const GRPOMain = memo(() => {
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const { t } = useTranslation();
//     const { GetPoData, GrpoItmData, postResponse, loading, error } = useSelector((state) => state.grpo);
//     const [filteredResults, setFilteredResults] = useState([]);
//     const [PoData, setPoData] = useState(null);
//     const [modalOpen, setModalOpen] = useState(false);
//     const [QRmodalOpen, setQRmodalOpen] = useState(false);
//     const [filteredDataState, setFilteredDataState] = useState(GrpoItmData);
//     const [formData, setFormData] = useState({});
//     const [tableRows, setTableRows] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [errorMessage, setErrorMessage] = useState({});
//     const [disabledFields, setDisabledFields] = useState(false);
//     const [activeField, setActiveField] = useState('');
//     const [editMode, setEditMode] = useState(false);
//     const prevModalOpenRef = useRef(modalOpen);
//     const [rowIndex, setRowIndex] = useState("")
//     const [QrTrigger, setQrTrigger] = useState(false);
//     const [openManual, setOpenManual] = useState(false);
//     const [qrScanResult, setQrScanResult] = useState(null);
//     // const [QRdata, setQrData] = useState("");
//     const [isSubmitVisible, setIsSubmitVisible] = useState(false);
//     const hasFetchedData = useRef(false);
//     // const [printedRows, setPrintedRows] = useState([]);
//     const [values, setValues] = useState({
//         po_Doc_Num: '',
//         vehicle_Number: '',
//         poDocEntry: '',
//         code: '',
//         customer: '',
//         docEntry: '',
//         last_Line_id: '',
//         no_Of_Coils: '',
//     });
//     const [dropdownVisibility, setDropdownVisibility] = useState({});
//    const { PrintLabel,setPrintedRows,printedRowss } = useQRModal();
//     const [callInProgress, setCallInProgress] = useState({
//         PostItem: false,
//         PoDataItem: false,
//         GetPoItem: false,
//     })

//     const isLoading = () => {
//         // Check if any loading state is true
//         return (
//             loading.GetGrpoData ||
//             loading.GetGrpoItmData ||
//             loading.postResponse
//         );
//     };

//     const tableHeader = useMemo(() => {
//         return GrpoItmData?.length > 0
//             ? Object.keys(GrpoItmData[0]).filter(header => header !== 'status' && header !== 'last_Line_id' && header !== 'batchNo')
//             : [];
//     }, [GrpoItmData]);

//     const initialFormData = useMemo(() => {
//         return tableHeader.reduce((acc, header) => {
//             acc[header] = "";
//             return acc;
//         }, {});
//     }, [tableHeader]);

//     useEffect(() => {
//         if (GetPoData?.length > 0) {
//             setPoData(GetPoData);
//             setFilteredResults(GetPoData);
//             if (values.docEntry) {
//                 // Find the specific document with matching docEntry
//                 const docData = GetPoData.find(item => item.docEntry === values.docEntry);
//                 if (docData) {
//                     // Append the full docData into setValues
//                     setValues(prevState => ({
//                         ...prevState,
//                         ...docData  // This will merge the found docData with the existing values in state
//                     }));
//                 }
//             }
//         }
//     }, [GetPoData]);

//     // error

//     useEffect(() => {
//         if (!GetPoData) {
//             setCallInProgress((prev) => ({
//                 ...prev,
//                 PoDataItem: true,
//             }));
//             dispatch(GetGrpoData());
//         }
//     }, [dispatch, GetPoData]);

//     useEffect(() => {
//         if (GetPoData) {
//             setCallInProgress((prev) => ({
//                 ...prev,
//                 PoDataItem: false,
//             }));
//         }

//         if (callInProgress.PoDataItem && error.GetPoDataError) {
//             toast.error(t('Error fetching first weight'));
//             setCallInProgress((prev) => ({
//                 ...prev,
//                 PoDataItem: false,
//             }));
//         }
//     }, [GetPoData, error]);

//     useEffect(() => {
//         if (GrpoItmData) {
//             setCallInProgress((prev) => ({
//                 ...prev,
//                 GetPoItem: false,
//             }));
//         }

//         if (callInProgress.GetPoItem && error.GrpoItmDataError) {
//             toast.error(t('Error fetching PO items'));
//             setCallInProgress((prev) => ({
//                 ...prev,
//                 GetPoItem: false,
//             }));
//         }
//     }, [GrpoItmData, error]);

//     useEffect(() => {
//         if (callInProgress.PostItem && postResponse === 'Success') {
//             toast.success(t('Submitted successfully'));
//             setFormData(initialFormData);
//             setTableRows([]);
//             setPoData(null);
//             setPrintedRows([]);
//             const docEntry = values?.poDocEntry
//             dispatch(GetGrpoItmData({ DocEntry: docEntry }));
//             dispatch(GetGrpoData());
//             // setIsLoading(true);
//             setValues({
//                 po_Doc_Num: '',
//                 vehicle_Number: '',
//                 poDocEntry: '',
//                 code: '',
//                 customer: '',
//                 DocEntry: '',
//                 last_Line_id: '',
//                 no_Of_Coils: '',
//             });

//             setCallInProgress((prev) => ({
//                 ...prev,
//                 PostItem: false,
//             }));
//         }
//         if (callInProgress.PostItem && error.postResponseError) {
//             const errormessage = error.postResponseError
//             toast.error(`${errormessage}`);

//             setCallInProgress((prev) => ({
//                 ...prev,
//                 PostItem: false,
//             }));
//         }
//     }, [postResponse, error, callInProgress]);

//     useEffect(() => {
//         if (prevModalOpenRef.current !== modalOpen) {
//             if (!modalOpen) {
//                 handleFieldClear();
//                 setEditMode(false);
//                 setErrorMessage({});
//                 //   setEditingFields([]);
//             }

//             prevModalOpenRef.current = modalOpen;
//         }
//     }, [modalOpen]);

//     const handleFieldClear = (header) => {
//         setFormData(initialFormData);
//     };

//     // Adding beforeunload event to block page reload
//     useEffect(() => {
//         const handleBeforeUnload = (event) => {
//             if (modalOpen || Object.keys(formData).length > 0 || tableRows.length > 0) {
//                 const message = "Are you sure you want to leave? Changes you made may not be saved.";
//                 event.returnValue = message; // Standard for most browsers
//                 return message; // For some older browsers
//             }
//         };

//         window.addEventListener("beforeunload", handleBeforeUnload);

//         return () => {
//             window.removeEventListener("beforeunload", handleBeforeUnload);
//         };
//     }, [modalOpen, formData, tableRows]);
//     // Handle input field changes
//     const handleInputChange = (e, fieldName) => {
//         const { value } = e.target;

//         setValues((prevValues) => ({
//             ...prevValues,
//             [fieldName]: value
//         }));
//         filterData(fieldName, value);
//         setDropdownVisibility((prevState) => ({
//             ...prevState,
//             [fieldName]: value ? true : false // Toggle dropdown visibility based on field input
//         }));
//     };

//     const filterData = (fieldName, value) => {
//         // Filter GetPoData based on the input field and value
//         const filtered = PoData.filter(item => {
//             if (fieldName === 'po_Doc_Num') {
//                 return item.po_Doc_Num && item.po_Doc_Num.toLowerCase().includes(value.toLowerCase()); // Check if poDocNum is defined
//             } else if (fieldName === 'vehicle_Number') {
//                 return item.vehicle_Number && item.vehicle_Number.toLowerCase().includes(value.toLowerCase()); // Check if vehicleNumber is defined
//             }
//             return false;
//         });
//         // Update filteredResults state with the filtered data
//         setFilteredResults(filtered);
//     };

//     const handleSelectSuggestion = (item) => {
//         setValues(item);
//         const docEntry = item.poDocEntry;
//         dispatch(GetGrpoItmData({ DocEntry: docEntry }))
//         setFormData(initialFormData);
//         setTableRows([]);
//         // After selecting, set a flag indicating selection is complete
//         setDropdownVisibility({
//             po_Doc_Num: false,
//             vehicle_Number: false
//         });
//     };
//     const handleInputChangeInternal = (value, header) => {
//         let filtered = [];
//         if (header === 'actual_Gross_Wt' || header === 'net_Wt' || header === 'gross_Wt') {
//             const { isValid, values: cleanedValue, error } = validateDecimalInput(value);
//             if (isValid) {
//                 value = cleanedValue
//             } else {
//                 value = cleanedValue
//             }
//         } else {
//             if (value === "") {
//                 if (header === 'coil_Id') {
//                     handleFieldClear(header);
//                 }
//                 setDisabledFields(false);
//             } else {
//                 filtered = commonFilter(GrpoItmData, header, value);
//             }
//         };
//         setFormData(prevData => ({
//             ...prevData,
//             [header]: value || ""
//         }));

//         // Ensure the filtered data only has unique values based on the header
//         const uniqueFilteredData = filtered.filter((value, index, self) => {
//             return index === self.findIndex((t) => t[header] === value[header]); // Compare based on header
//         });

//         // Update the filtered data state
//         setFilteredData(uniqueFilteredData);
//     };

//     const handleDropClick = (item, header) => {
//         const filtered = GrpoItmData.filter(items => {
//             return (items[header] || "").toString().toLowerCase().includes((item[header] || "").toLowerCase());
//         });
//         if (filtered.length !== 0) {
//             setFormData(prevData => {
//                 const updatedData = { ...prevData };
//                 const fieldsToRetain = ['item_Code', 'item_Name', 'coil_Id'];
//                 if (header === 'coil_Id') {
//                     Object.keys(updatedData).forEach(field => {
//                         updatedData[field] = filtered[0][field] || "";
//                     });
//                     setDisabledFields(true);
//                 }
//                 else if (header === 'item_Code' || header === 'item_Name') {
//                     updatedData['item_Code'] = item['item_Code'] || "";
//                     updatedData['item_Name'] = item['item_Name'] || "";
//                     Object.keys(updatedData).forEach(field => {
//                         if (!fieldsToRetain.includes(field)) {
//                             updatedData[field] = "";
//                         }
//                     });
//                     setDisabledFields(false);
//                 }
//                 return updatedData;
//             });
//         }
//         setErrorMessage(prevState => ({
//             ...prevState,
//             [header]: ""
//         }));
//         setActiveField('');
//     }

//     const handleAddRow = (formData) => {
//         const isItemCodeValid = GrpoItmData.some(item => item.item_Code === formData.item_Code);
//         const isItemNameValid = GrpoItmData.some(item => item.item_Name === formData.item_Name);
//         const isCoilIdValid = tableRows.some(row => row.coil_Id === formData.coil_Id);
//         let newErrorMessage = {};

//         if (isCoilIdValid && !editMode) {
//             newErrorMessage.coil_Id = `coil_Id ${formData.coil_Id} already exists.`;
//         } else if (!isItemCodeValid) {
//             newErrorMessage.item_Code = `Error: item_Code ${formData.item_Code} does not exist in the system.`;
//         } else if (!isItemNameValid) {
//             newErrorMessage.item_Name = `Error: item_Name ${formData.item_Name} does not exist in the system.`;
//         }

//         if (Object.keys(newErrorMessage).length > 0) {
//             setErrorMessage(newErrorMessage);
//             return;
//         }
//         if (tableRows.length >= Number(values.no_Of_Coils) && !editMode) {
//             toast.error(`You cannot add more than ${values.no_Of_Coils} rows.`);
//             return; // Prevent adding more rows
//         }

//         // Generate the batchNo and lineId only if all validations pass
//         const currentDate = new Date();
//         const formattedDate = `${String(currentDate.getDate()).padStart(2, '0')}${String(currentDate.getMonth() + 1).padStart(2, '0')}`;
//         const yearAlphabet = String.fromCharCode(65 + (currentDate.getFullYear() - 2025));
//         const lastTableLine = Math.max(...tableRows.map(item => item.line_Id || 0));

//         // Line ID calculation
//         const lineId = formData.line_Id || (lastTableLine > values.last_Line_id ? lastTableLine + 1 : values.last_Line_id + 1);

//         const batch_Number = `${formData.item_Code}/${values.docEntry}W${formattedDate}${yearAlphabet}${lineId}`;

//         // Prepare row data with the generated batchNo and lineId
//         const rowWithBatchNo = { ...formData, batch_Number, line_Id: lineId,
//             order_Num: values.po_Doc_Num,CreatedDate :currentDate.toLocaleDateString() };

//         // Add or update row based on edit mode
//         if (editMode) {
//             const updatedTableRows = [...tableRows];
//             updatedTableRows[rowIndex] = rowWithBatchNo;
//             setTableRows(updatedTableRows);
//         } else {
//             setTableRows(prevTable => [...prevTable, rowWithBatchNo]);
//         }

//         setIsSubmitVisible(true);
//         setEditMode(false);
//         setModalOpen(false);
//     };

//     const handleCloseModal = () => {
//         setModalOpen(false);
//         setEditMode(false)
//         setFormData(initialFormData);
//     };

//     const openModal = () => {
//         setModalOpen(!modalOpen)
//         setFilteredData(GrpoItmData);
//         setFilteredDataState(GrpoItmData);
//         setDisabledFields(false);
//         setFormData(initialFormData);
//     };
//     const onEdit = (action, rowIndex) => {
//         const selectedRow = tableRows[rowIndex];
//         setFormData(selectedRow);
//         setRowIndex(rowIndex);
//         setModalOpen(!modalOpen);
//         setDisabledFields(true);
//         setEditMode(true);
//     }

//     const handleQrScan = (scanResult) => {
//         setOpenManual(true);
//         setFormData(initialFormData);
//         scanResult = (scanResult);
//         // Check if scanResult is an object before iterating through its keys
//         if (scanResult && typeof scanResult === "string") {
//             setQrTrigger(true);
//             setFormData((prevFormData) => {
//                 let updatedFormData = { ...prevFormData };
//                 updatedFormData.coil_Id = scanResult;
//                 setDisabledFields(false);
//                 return updatedFormData;

//             });
//             const header = 'coil_Id';
//             const item = { 'coil_Id': scanResult }
//             handleDropClick(item, header)
//         } else {
//             console.error("scanResult is not a valid object", scanResult);
//         }
//     }

//     const handleSubmit = (e) => {

//             e.preventDefault();
//             if (tableRows.length > Number(values.no_Of_Coils)) {
//                 // toast.error(`Number of coils must match: ${values.no_Of_Coils} QTY`);
//                 toast.error(t("Number of coils must match"));
//                 return; // Prevent form submission if they don't match
//             }

//             const allPrinted = tableRows.every((_, index) => printedRowss[index]);
//             if (!allPrinted) {
//                 toast.error(t('All rows must be printed before submitting'));
//                 return; // Prevent form submission if not all rows are printed
//             }

//             showSubmitConfirmation(() => {
//             // Assuming GrpoItmData contains previously existing line data
//             const maxLineId = GrpoItmData.length > 0 ? Math.max(...GrpoItmData.map(item => item.line_Id)) : 0;
//             // Prepare the final data object to be dispatched
//             const currentDate = new Date().toLocaleDateString();
//             const postBatch = tableRows.map((row) => ({
//                 batchNumber: row.batch_Number,
//                 batchDetails: JSON.stringify({
//                     PONumber: values.po_Doc_Num,
//                     BatchNumber:row.batch_Number,
//                     Itemcode: row.item_Code,
//                     ItemName: row.item_Name,
//                     netWt: row.net_Wt,
//                     ActualWt: row.actual_Gross_Wt,
//                     CreatedDate:currentDate
//                   }),
//                   itemName:row.item_Name,
//                   itemCode:row.item_Code
//               }));
//             const dataToSend = {
//                 generalData: {
//                     code: values.code,  // This should be dynamically set if necessary
//                     company: "MELWA_TEST_07022018",  // Ensure this is dynamic based on your context
//                     u_PurDocEntry: values.poDocEntry,
//                     u_PurDocNo: values.po_Doc_Num,
//                     U_CustCode: values.customer,
//                     DocEntry: values.docEntry.toString()
//                 },
//                 dataList: tableRows.map(row => ({
//                     coil_Id: row.coil_Id,
//                     line_Id: row.line_Id || null,
//                     item_Code: row.item_Code,
//                     item_Name: row.item_Name,
//                     net_Wt: row.net_Wt,
//                     gross_Wt: row.gross_Wt,
//                     actual_Gross_Wt: row.actual_Gross_Wt,
//                     status: "Open",
//                     batchNo: row.batch_Number,
//                 })),
//                 batchData: postBatch
//             };
//             setCallInProgress(
//                 (prev) => ({
//                     ...prev,
//                     PostItem: true
//                 })
//             )
//             // Dispatch action with the prepared data
//             dispatch(PostItemCoilId(dataToSend));
//             // toast.success("Submitted successfully!")
//             // setIsLoading(true);
//         })
//     };

//     const handleNavigateConfirmation = () => {
//         if (tableRows.length > 0) {
//             showNavigateConfirmation(goBack);
//         } else {
//             goBack();
//         }
//     };

//     // navigate to the previous page
//     const goBack = () => {
//         setPrintedRows([]);
//         navigate("/production/");
//     };

//     return (
//         <>
//             {/* <Header /> */}
//             <div className="container mainDiv">
//                 <div className="col-12 gap-2 mb-4 d-flex align-items-center justify-content-between">
//                     <button onClick={handleNavigateConfirmation} className="goBackButton">
//                         <BiArrowBack size={24} />
//                     </button>
//                     <p className="m-0 fw-medium mx-3">GRPO</p>
//                 </div>
//                 <GRPOSearch
//                     inputFields={['po_Doc_Num', 'vehicle_Number', 'no_Of_Coils']}
//                     values={values}
//                     filteredResults={filteredResults}
//                     handleSelectSuggestion={handleSelectSuggestion}
//                     dropdownVisibility={dropdownVisibility}
//                     handleInputChange={handleInputChange}
//                     setActiveField={setActiveField}
//                     activeField={activeField}
//                     setDropdownVisibility={setDropdownVisibility}
//                 />
//                 <div className="row mb-1">
//                     <div className="col-12 d-flex justify-content-end">
//                         {(values.po_Doc_Num && dropdownVisibility.po_Doc_Num === false) || (values.vehicle_Number && dropdownVisibility.vehicle_Number === false) ? (
//                             <div className="col-12 d-flex justify-content-between">
//                                 {values.no_Of_Coils && (
//                                     <p className="m-0">{t('Total Coils')}: {values.no_Of_Coils}</p>
//                                 )}
//                                 {values.remaining_Coils && (
//                                     <p className="m-0">{t('Remaining Coils')}: {values.remaining_Coils}</p>
//                                 )}
//                                 <button onClick={openModal} className="button xs">
//                                 {t('Add Item')}
//                                 </button>
//                             </div>
//                         ) : null}
//                     </div>
//                 </div>
//                 <div className="tableMin">
//                     <GRPOTable
//                         tableHeader={tableHeader}
//                         tablebody={tableRows}
//                         setTableBody={setTableRows}
//                         setModalOpen={setModalOpen}
//                         setFormData={setFormData}
//                         // setPrintedRows={setPrintedRows}
//                         // printedRows={printedRowss}
//                         onEdit={onEdit}
//                         // onPrint={onPrint}
//                     />
//                     <GRPOModal
//                         modalOpen={modalOpen}
//                         setModalOpen={setModalOpen}
//                         handleCloseModal={handleCloseModal}
//                         headers={tableHeader}
//                         setFormData={setFormData}
//                         formData={formData}
//                         filteredData={filteredData}
//                         handleInputChangeInternal={handleInputChangeInternal}
//                         handleDropClick={handleDropClick}
//                         activeField={activeField}
//                         handleAddRow={handleAddRow}
//                         setActiveField={setActiveField}
//                         disabledFieldsTrigger={disabledFields}
//                         editMode={editMode}
//                         errorMessage={errorMessage}
//                         setFilteredDataState={setFilteredDataState}
//                         filteredDataState={filteredDataState}
//                         handleQrScan={handleQrScan}
//                         setQrScanResult={setQrScanResult}
//                         openManual={openManual}
//                         setOpenManual={setOpenManual}
//                         tableRows={tableRows}

//                     />
//                 </div>
//                 {/* <QRCodeGenerator
//                     QRdata={QRdata}
//                     openQRModal={QRmodalOpen}
//                     handleCloseQRModal={handleCloseQRModal}
//                     rowIndex={rowIndex}
//                     setPrintedRows={setPrintedRows}

//                 /> */}
//                 <div className="submit-button-container">
//                     {isSubmitVisible && (
//                         <button onClick={handleSubmit} className="button xs">
//                             {t('Submit')}
//                         </button>
//                     )}
//                 </div>
//                 <div>
//                 </div>
//             </div>

//             <Toaster
//                 position="top-center"
//                 toastOptions={{
//                     style: { fontSize: '16px', padding: '16px', width: '400px', borderRadius: '8px' },
//                 }} />

//             {isLoading() && (
//                 <div className="loader">
//                     <HashLoader color="#ed1c24" />
//                 </div>
//             )}
//             <Footer />
//         </>
//     );
// });

// export default GRPOMain;
import React, { useState, useEffect, useMemo, memo, useRef } from "react";
import GRPOSearch from "./GRPOSearch";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  GetGrpoData,
  GetGrpoItmData,
  PostedCoils,
  PostItemCoilId,
} from "../../../APIServices/ProductionService/GRPOServices/grpoThunk";
import GRPOTable from "./GRPOTable";
import GRPOModal from "./GRPOModal";
import { HashLoader } from "react-spinners";
import {
  commonFilter,
  validateDecimalInput,
} from "../../../SharedFiles/Helper/utils";
import { BiArrowBack } from "react-icons/bi";
import "./GRPO.css";
import Footer from "../../../SharedFiles/Footer/Footer";
import { toast, Toaster } from "react-hot-toast";
import QRCodeGenerator from "../../../SharedFiles/QRCode/qrGenerator";
import {
  showNavigateConfirmation,
  showSubmitConfirmation,
} from "../../../SharedFiles/WarningMessage/deleteWarning";
import { useTranslation } from "react-i18next";
import { useQRModal } from "../../../../Context/QrContext";
import DynamicTable from "../../../SharedFiles/CommonTable/dynamicTable";

const GRPOMain = memo(() => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { GetPoData, GrpoItmData, PostedCoil, postResponse, loading, error } =
    useSelector((state) => state.grpo);
    
  const [filteredResults, setFilteredResults] = useState([]);
  const [PoData, setPoData] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [tableShow, setTableShow] = useState(false);
  const [filteredDataState, setFilteredDataState] = useState(GrpoItmData);
  const [formData, setFormData] = useState({});
  const [tableRows, setTableRows] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [errorMessage, setErrorMessage] = useState({});
  const [disabledFields, setDisabledFields] = useState(false);
  const [activeField, setActiveField] = useState("");
  const [editMode, setEditMode] = useState(false);
  const prevModalOpenRef = useRef(modalOpen);
  const [rowIndex, setRowIndex] = useState("");
  const [QrTrigger, setQrTrigger] = useState(false);
  const [openManual, setOpenManual] = useState(false);
  const [qrScanResult, setQrScanResult] = useState(null);
  const [printData, setPrintData] = useState("");
  // const [QRdata, setQrData] = useState("");
  // const [isSubmitVisible, setIsSubmitVisible] = useState(false);
  const hasFetchedData = useRef(false);
  // const [printedRows, setPrintedRows] = useState([]);
  const [values, setValues] = useState({
    po_Doc_Num: "",
    vehicle_Number: "",
    poDocEntry: "",
    code: "",
    customer: "",
    docEntry: "",
    last_Line_id: "",
    // no_Of_Coils: "",
    remaining_Coils: "",
  });
  const [dropdownVisibility, setDropdownVisibility] = useState({});
  const { PrintLabel } = useQRModal();
  const [callInProgress, setCallInProgress] = useState({
    PostItem: false,
    PoDataItem: false,
    GetPoItem: false,
    showPostGrpo: false,
  });

  const isLoading = () => {
    // Check if any loading state is true
    return (
      loading.GetGrpoData ||
      loading.GetGrpoItmData ||
      loading.postResponse ||
      loading.PostedCoil
    );
  };

  const ModelField = useMemo(() => {
    return GrpoItmData?.length > 0
      ? Object.keys(GrpoItmData[0]).filter(
          (header) =>
            header !== "status" &&
            header !== "last_Line_id" &&
            header !== "batchNo" &&
            header !== "no_Of_Coils" &&
            header !== "remaining_Coils"
        )
      : [];
  }, [GrpoItmData]);
  const tableHeader = useMemo(() => {
    return PostedCoil?.length > 0
      ? Object.keys(PostedCoil[0]).filter(
          (header) =>
            header !== "status" &&
            header !== "last_Line_id" &&
            header !== "batchNo" &&
            header !== "no_Of_Coils" &&
            header !== "remaining_Coils"
        )
      : [];
  }, [PostedCoil]);

  const initialFormData = useMemo(() => {
    return ModelField.reduce((acc, header) => {
      acc[header] = "";
      return acc;
    }, {});
  }, [ModelField]);

  useEffect(() => {
    if (GetPoData?.length > 0) {
      setPoData(GetPoData);
      setFilteredResults(GetPoData);
      // if (values.docEntry) {
      //   // Find the specific document with matching docEntry
      //   const docData = GetPoData.find(
      //     (item) => item.docEntry === values.docEntry
      //   );
      //   console.log("GetPoData",GetPoData);

      //   if (docData) {
      //     // Append the full docData into setValues
      //     setValues((prevState) => ({
      //       ...prevState,
      //       ...docData,
      //     }));
      //   }
      // }
    }
  }, [GetPoData]);
  useEffect(() => {
    if (!GetPoData) {
      setCallInProgress((prev) => ({
        ...prev,
        PoDataItem: true,
      }));
      dispatch(GetGrpoData());
    }
  }, [dispatch, GetPoData]);
  const GrpoChecker = () => {
    if (callInProgress.PoDataItem) {
      if (GetPoData) {
        setCallInProgress({ ...callInProgress, PoDataItem: false });
      } else if (error.GetPoDataError) {
        toast.error(t("Error fetching first weight"));
        setCallInProgress({ ...callInProgress, PoDataItem: false });
      }
    }
    if (callInProgress.GetPoItem) {
      if (GrpoItmData) {
        setCallInProgress({ ...callInProgress, GetPoItem: false });
      } else if (error.GrpoItmDataError) {
        toast.error(t("Error fetching PO items"));
        setCallInProgress({ ...callInProgress, GetPoItem: false });
      }
    }

    if (callInProgress.showPostGrpo) {
      if (PostedCoil && PostedCoil.length > 0) {
        setTableShow(true);
        setCallInProgress({ ...callInProgress, showPostGrpo: false });
      } else if (error.PostedCoilError || error.GrpoItmDataError) {
        setTableShow(true);
        // toast.error(t("Error fetching posted coils"));
        setCallInProgress({ ...callInProgress, showPostGrpo: false });
      }
    }

    if (callInProgress.PostItem) {
      if (postResponse === "Success") {
        toast.success(t("Submitted successfully"));
        const currentDate = new Date().toLocaleDateString();
        const data = {
          Order_Number: printData.PONumber,
          batch_Number: printData.BatchNumber,
          item_Code: printData.Itemcode,
          item_Name: printData.ItemName,
          Actual_Weight: JSON.stringify(Number(printData.ActualWt)),
          CreatedDate: printData.CreatedDate,
        };
        // const data = {
        //   PONumber: printData.PONumber,
        //   BatchNumber: printData.BatchNumber,
        //   Itemcode: printData.Itemcode,
        //   ItemName: printData.ItemName,
        //   ActualWt: printData.ActualWt,
        //   CreatedDate: printData.CreatedDate,
        // };
        PrintLabel(data, null, "GRPO", "");
        clear();
        setCallInProgress({ ...callInProgress, PostItem: false });
      } else if (error.postResponseError) {
        toast.error(`${error.postResponseError}`);
        setCallInProgress({ ...callInProgress, PostItem: false });
      }
    }
  };

  const clear = () => {
    setFormData(initialFormData);
    setModalOpen(false);
    setPoData(null);
    setTableShow(true);
    dispatch(
      GetGrpoItmData({
        DocEntry: values?.docEntry,
        PoEntry: values?.poDocEntry,
      })
    );
    dispatch(
      PostedCoils({ DocEntry: values?.docEntry, PoEntry: values.poDocEntry })
    );
    // dispatch(GetGrpoData());
  };
  useEffect(() => {
    GrpoChecker();
  }, [GetPoData, GrpoItmData, postResponse, error, callInProgress, PostedCoil]);

  useEffect(() => {
    if (prevModalOpenRef.current !== modalOpen) {
      if (!modalOpen) {
        handleFieldClear();
        setEditMode(false);
        setErrorMessage({});
        //   setEditingFields([]);
      }

      prevModalOpenRef.current = modalOpen;
    }
  }, [modalOpen]);

  const handleFieldClear = (header) => {
    setFormData(initialFormData);
  };

  // Adding beforeunload event to block page reload
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (
        modalOpen ||
        Object.keys(formData).length > 0 ||
        tableRows.length > 0
      ) {
        const message =
          "Are you sure you want to leave? Changes you made may not be saved.";
        event.returnValue = message; // Standard for most browsers
        return message; // For some older browsers
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [modalOpen, formData, tableRows]);
  // Handle input field changes
  const handleInputChange = (e, fieldName) => {
    const { value } = e.target;
    setValues((prevValues) => ({
      ...prevValues,
      [fieldName]: value,
    }));
    filterData(fieldName, value);
    setDropdownVisibility((prevState) => ({
      ...prevState,
      [fieldName]: value ? true : false, // Toggle dropdown visibility based on field input
    }));
  };

  const filterData = (fieldName, value) => {
    // Filter GetPoData based on the input field and value
    const filtered = PoData.filter((item) => {
      if (fieldName === "po_Doc_Num") {
        return (
          item.po_Doc_Num &&
          item.po_Doc_Num.toLowerCase().includes(value.toLowerCase())
        ); // Check if poDocNum is defined
      } else if (fieldName === "vehicle_Number") {
        return (
          item.vehicle_Number &&
          item.vehicle_Number.toLowerCase().includes(value.toLowerCase())
        ); // Check if vehicleNumber is defined
      }
      return false;
    });
    // Update filteredResults state with the filtered data
    setFilteredResults(filtered);
  };

  const handleSelectSuggestion = (item, fieldName) => {
    setValues((prevValues) => ({
      ...prevValues,
      ...item,
    }));

    setCallInProgress({ ...callInProgress, GetPoItem: true });
    dispatch(
      GetGrpoItmData({ DocEntry: item?.docEntry, PoEntry: item.poDocEntry })
    );
    setCallInProgress({ ...callInProgress, showPostGrpo: true });
    dispatch(
      PostedCoils({ DocEntry: item.docEntry, PoEntry: item.poDocEntry })
    );
    setFormData(initialFormData);
    setTableRows([]);
    setDropdownVisibility({
      po_Doc_Num: false,
      vehicle_Number: false,
    });
  };

  const handleInputChangeInternal = (value, header) => {
    setErrorMessage((prevState) => ({
      ...prevState,
      [header]: "",
    }));
    let filtered = [];
    if (
      header === "actual_Gross_Wt" ||
      header === "net_Wt" ||
      header === "gross_Wt"
    ) {
      const {
        isValid,
        values: cleanedValue,
        error,
      } = validateDecimalInput(value);
      if (isValid) {
        value = cleanedValue;
      } else {
        value = cleanedValue;
      }
    } else {
      if (value === "") {
        if (header === "coil_Id") {
          handleFieldClear(header);
        }
        setDisabledFields(false);
      } else {
        filtered = commonFilter(GrpoItmData, header, value);
      }
    }
    setFormData((prevData) => ({
      ...prevData,
      [header]: value || "",
    }));

    // Ensure the filtered data only has unique values based on the header
    const uniqueFilteredData = filtered.filter((value, index, self) => {
      return index === self.findIndex((t) => t[header] === value[header]); // Compare based on header
    });

    // Update the filtered data state
    setFilteredData(uniqueFilteredData);
  };
  const normalize = (val) =>
    val?.toString().trim().toLowerCase();
  
  const handleDropClick = (item, header) => {
    // console.log("item",item)
    // console.log("header",header)
    // console.log("GrpoItmData",GrpoItmData)
    // const filtered = GrpoItmData.filter((items) => {
    //   return (items[header] || "")
    //     .toString()
    //     .toLowerCase()
        
    // });
      const selectedValue = normalize(item[header]);
      const filtered = GrpoItmData.filter((row) => {
        return normalize(row[header]) === selectedValue;
      });
    if (filtered.length !== 0) {
      setFormData((prevData) => {
        const updatedData = { ...prevData };
        const fieldsToRetain = ["item_Code", "item_Name", "coil_Id"];
        if (header === "coil_Id") {
          Object.keys(updatedData).forEach((field) => {
            updatedData[field] = filtered[0][field] || "";
          });
          setDisabledFields(true);
        } else if (header === "item_Code" || header === "item_Name") {
          updatedData["item_Code"] = item["item_Code"] || "";
          updatedData["item_Name"] = item["item_Name"] || "";
          Object.keys(updatedData).forEach((field) => {
            if (!fieldsToRetain.includes(field)) {
              updatedData[field] = "";
            }
          });
          setDisabledFields(false);
        }
        return updatedData;
      });
    }
    setErrorMessage((prevState) => ({
      ...prevState,
      [header]: "",
    }));
    setActiveField("");
  };
  const handleAddRow = (formData) => {
    const isItemCodeValid = GrpoItmData.some(
      (item) => item.item_Code === formData.item_Code
    );
    const isItemNameValid = GrpoItmData.some(
      (item) => item.item_Name === formData.item_Name
    );
    const isCoilIdValid = PostedCoil?.some(
      (item) => item?.coil_Id === formData.coil_Id
    
    );
    let newErrorMessage = {};
    if (!isItemCodeValid) {
      newErrorMessage.item_Code = `Error: item_Code ${formData.item_Code} does not exist in the system.`;
    }
    if (!isItemNameValid) {
      newErrorMessage.item_Name = `Error: item_Name ${formData.item_Name} does not exist in the system.`;
    }
    if(isCoilIdValid){
      newErrorMessage.coil_Id = `Error: coil_Id ${formData.coil_Id} already exist in the system.`;
    }

    if (Object.keys(newErrorMessage).length > 0) {
      setErrorMessage(newErrorMessage);
      return;
    }
    // Generate batch number and line ID
    const currentDate = new Date();
    const formattedDate = `${String(currentDate.getDate()).padStart(
      2,
      "0"
    )}${String(currentDate.getMonth() + 1).padStart(2, "0")}`;
    const yearAlphabet = String.fromCharCode(
      65 + (currentDate.getFullYear() - 2025)
    );

    const lastLineIdFromGRPO =
      GrpoItmData.length > 0
        ? Math.max(...GrpoItmData.map((item) => item.line_Id || 0))
        : 0;

    const lineId =
      formData.line_Id ||
      (values.last_Line_id
        ? Math.max(values.last_Line_id + 1, lastLineIdFromGRPO + 1)
        : lastLineIdFromGRPO + 1);

    const batch_Number = `${formData.item_Code}/${values.docEntry}W${formattedDate}${yearAlphabet}${lineId}`;

    const postBatch = [
      {
        batchNumber: batch_Number,
        batchDetails: JSON.stringify({
          PONumber: values.po_Doc_Num,
          BatchNumber: batch_Number,
          Itemcode: formData.item_Code,
          ItemName: formData.item_Name,
          netWt: formData.net_Wt,
          ActualWt: formData.actual_Gross_Wt,
          CreatedDate: currentDate.toLocaleDateString(),
        }),
        itemName: formData.item_Name,
        itemCode: formData.item_Code,
      },
    ];
    const dataToSend = [
      {
        generalData: {
          code: values.code,
          company: "MELWA_TEST_07022018", // Update if dynamic
          u_PurDocEntry: values.poDocEntry,
          u_PurDocNo: values.po_Doc_Num,
          u_CustCode: values.customer,
          docEntry: values.docEntry.toString(),
        },
        dataList: [
          {
            coil_Id: formData.coil_Id,
            line_Id: lineId,
            item_Code: formData.item_Code,
            item_Name: formData.item_Name,
            net_Wt: formData.net_Wt,
            gross_Wt: formData.gross_Wt,
            actual_Gross_Wt: formData.actual_Gross_Wt,
            status: "Open",
            batchNo: batch_Number,
            last_Line_id: values.last_Line_id || 0,
          },
        ],
        batchData: postBatch,
      },
    ];
    setPrintData({
      PONumber: values.po_Doc_Num,
      BatchNumber: batch_Number,
      Itemcode: formData.item_Code,
      ItemName: formData.item_Name,
      netWt: formData.net_Wt,
      ActualWt: formData.actual_Gross_Wt,
      CreatedDate: currentDate.toLocaleDateString(),
    });
    showSubmitConfirmation(() => {
      setCallInProgress((prev) => ({ ...prev, PostItem: true }));
      dispatch(PostItemCoilId(dataToSend));
    });
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    // setEditMode(false);
    setActiveField("");
    setFormData(initialFormData);
  };

  const openModal = () => {
    setModalOpen(!modalOpen);
    setFilteredData(GrpoItmData);
    setFilteredDataState(GrpoItmData);
    setDisabledFields(false);
    setFormData(initialFormData);
  };

  const handleQrScan = (scanResult) => {
    setOpenManual(true);
    setFormData(initialFormData);
    scanResult = scanResult;
    // Check if scanResult is an object before iterating through its keys
    if (scanResult && typeof scanResult === "string") {
      setQrTrigger(true);
      setFormData((prevFormData) => {
        let updatedFormData = { ...prevFormData };
        updatedFormData.coil_Id = scanResult;
        setDisabledFields(false);
        return updatedFormData;
      });
      const header = "coil_Id";
      const item = { coil_Id: scanResult };
      handleDropClick(item, header);
    } else {
      console.error("scanResult is not a valid object", scanResult);
    }
  };
  const handleNavigateConfirmation = () => {
    if (tableRows.length > 0) {
      showNavigateConfirmation(goBack);
    } else {
      goBack();
    }
  };

  // navigate to the previous page
  const goBack = () => {
    setValues({
      po_Doc_Num: "",
      vehicle_Number: "",
      no_Of_Coils: "",
      remaining_Coils: "",
      poDocEntry: "",
      code: "",
      customer: "",
      DocEntry: "",
      last_Line_id: "",
    });

    setTableShow(false);
    navigate("/production/");
  };

  return (
    <>
      {/* <Header /> */}
      <div className="container mainDiv">
        <div className="col-12 gap-2 mb-4 d-flex align-items-center justify-content-between">
          <button onClick={handleNavigateConfirmation} className="goBackButton">
            <BiArrowBack size={24} />
          </button>
          <p className="m-0 fw-medium mx-3">GRPO</p>
        </div>
        <GRPOSearch
          inputFields={["po_Doc_Num", "vehicle_Number", "no_Of_Coils"]}
          values={values}
          filteredResults={filteredResults}
          handleSelectSuggestion={handleSelectSuggestion}
          dropdownVisibility={dropdownVisibility}
          handleInputChange={handleInputChange}
          setActiveField={setActiveField}
          activeField={activeField}
          setDropdownVisibility={setDropdownVisibility}
        />
        <div className="row mb-1">
          <div className="col-12 d-flex justify-content-end">
            {tableShow && (
              <div className="col-12 d-flex justify-content-between">
                {GrpoItmData?.[0]?.no_Of_Coils && (
                  <p className="m-0">
                    {t("Total Coils")}: {GrpoItmData[0].no_Of_Coils}
                  </p>
                )}

                {GrpoItmData?.[0]?.remaining_Coils && (
                  <p className="m-0">
                    {t("Remaining Coils")}: {GrpoItmData[0].remaining_Coils}
                  </p>
                )}

             
                <button onClick={openModal} className="button xs">
                  {t("Add Item")}
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="tableMin">
          {tableShow && (
            <DynamicTable
              header={tableHeader}
              tablebody={PostedCoil}
              pageName={"GRPO"}
            />
          )}

          <GRPOModal
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            handleCloseModal={handleCloseModal}
            headers={ModelField}
            setFormData={setFormData}
            formData={formData}
            filteredData={filteredData}
            handleInputChangeInternal={handleInputChangeInternal}
            handleDropClick={handleDropClick}
            activeField={activeField}
            handleAddRow={handleAddRow}
            setActiveField={setActiveField}
            disabledFieldsTrigger={disabledFields}
            editMode={editMode}
            errorMessage={errorMessage}
            setFilteredDataState={setFilteredDataState}
            filteredDataState={filteredDataState}
            handleQrScan={handleQrScan}
            setQrScanResult={setQrScanResult}
            openManual={openManual}
            setOpenManual={setOpenManual}
            tableRows={tableRows}
          />
        </div>
      </div>

      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            fontSize: "16px",
            padding: "16px",
            width: "400px",
            borderRadius: "8px",
          },
        }}
      />

      {isLoading() && (
        <div className="loader">
          <HashLoader color="#ed1c24" />
        </div>
      )}
      <Footer />
    </>
  );
});

export default GRPOMain;
